import { apiClient } from '@/shared/services/client'
import type { WebinarReporte } from '../types'

export const webinarsAnalyticsApi = {
  async obtenerReporteGrupoFarma(): Promise<WebinarReporte> {
    const { data } = await apiClient.get<WebinarReporte>('/webinars-reporte/grupofarma')
    return data
  },

  async exportarGrupoFarma(): Promise<Blob> {
    const { data } = await apiClient.get<Blob>('/webinars-reporte/grupofarma/export', {
      responseType: 'blob',
    })
    return data
  },
}
